import AddTaskOutlinedIcon from "@mui/icons-material/AddTaskOutlined";
import { IconButton, Link, Tooltip } from "@mui/material";
import React, { useState } from "react";
import { API_PERMISSION_URL } from "../../Constants/Constants";
import AxiosInstance from "../../services/AxiosInstance";
import ApiForm from "./ApiForm";

function ApiDialog({
  apiId = "",
  apiName,
  variant = "button", // 'button' for add, 'link' for edit
  onSuccess,
}) {
  const [open, setOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleClickOpen = async () => {
    if (apiId && apiId !== "") {
      setLoading(true);
      try {
        const response = await AxiosInstance.get(
          API_PERMISSION_URL + apiId
        );
        setEditData(response.data);
        setOpen(true);
      } catch (error) {
        console.error("Error fetching API data:", error);
      } finally {
        setLoading(false);
      }
    } else {
      setEditData(null);
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setEditData(null);
  };

  const renderTrigger = () => {
    if (variant === "link" && apiId) {
      return (
        <Link
          component="button"
          onClick={handleClickOpen}
          disabled={loading}
          sx={{
            cursor: "pointer",
            textDecoration: "none",
            color: "primary.main",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          {apiName}
        </Link>
      );
    }

    return (
      <Tooltip
        title="API"
        onClick={handleClickOpen}
        disabled={loading}
      >
        <IconButton
          sx={{
            cursor: "pointer",
            margin: "2px",
            color: (theme) => theme.palette.grey[500],
            borderRadius: 2,
            border: 1,
            borderColor: "divider",
          }}
        >
          <AddTaskOutlinedIcon color="primary" />
        </IconButton>
      </Tooltip>
    );
  };

  return (
    <>
      {renderTrigger()}
      <ApiForm      
        open={open}
        onClose={handleClose}
        editData={editData}
        onSuccess={onSuccess}
        isEditMode={Boolean(editData)}
      />
    </>
  );
}
export default ApiDialog;
